<template>
    <div class="login-body">
        <div class="login-image">
            <img :src="'layout/images/pages/login-on' + color + '.png'" alt="GA Moosehead" />
        </div>
        <div class="login-panel p-fluid grid">
            <div class="flex-column col-4">
                <div class="flex align-items-center logo-container">
                    <img :src="'layout/images/logo-' + color + '.png'" class="login-logo" />
                    <img :src="'layout/images/appname-' + color + '.png'" class="login-appname" />
                </div>
                <form @submit="loginWithEmailAndPassword">
                    <h4 class="pb-3">Log In</h4>
                    <div
                        class="mb-3 border bg-warning border-warning rounded"
                        style="--bs-bg-opacity: 0.2"
                        v-if="!!this.message"
                    >
                        {{ this.message }}
                    </div>
                    <div>
                        <div class="grid mb-3 mr-3">
                            <label class="form-label col-4" for="email">Email:</label>
                            <input
                                class="form-control col-8"
                                type="email"
                                name="email"
                                id="email"
                                v-model="this.email"
                                placeholder="name@example.com"
                                required
                            />
                        </div>
                        <div class="grid mr-3">
                            <label class="form-label col-4" for="password">Password:</label>
                            <input
                                :type="this.isPasswordVisible ? 'text' : 'password'"
                                class="form-control col-8"
                                name="password"
                                placeholder="password"
                                v-model="this.password"
                                required
                            />
                        </div>
                        <div class="grid align-content-end">
                            <div class="col-4" />
                            <div class="col-8">
                                <input
                                    class="form-check-input pl-3"
                                    type="checkbox"
                                    aria-label="Checkbox for following text input"
                                    v-model="this.isPasswordVisible"
                                />
                                <span class="mr-3">Show</span>
                                <router-link to="/reset-password">Forgot Password?</router-link>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center">
                            <Button class="btn btn-primary" type="submit" label="Log In" />
                        </div>
                    </div>
                </form>
                <p class="align-self-center mt-3 mb-3">OR</p>
                <div>
                    <Button
                        @click="this.$store.dispatch('signInWithGoogle')"
                        type="button"
                        label="Log In with Google"
                    />
                </div>
                <div class="ms-3 mt-3">
                    <span class="text-end">Not registered yet? <router-link to="/sign-up">Sign Up</router-link></span>
                </div>
            </div>
        </div>
    </div>
    <div class="login-footer flex align-items-center">
        <AppFooter :colorScheme="color" />
    </div>
</template>

<script>
import AppFooter from '@/AppFooter.vue';

export default {
    components: { AppFooter },
    data() {
        return {
            email: this.$route.query.email || '',
            password: '',
            message: '',
            isPasswordVisible: false,
            color: this.$appState.defaultColorScheme,
        };
    },
    methods: {
        async loginWithEmailAndPassword(event) {
            event.preventDefault();

            const formData = {
                email: this.email,
                password: this.password,
            };

            try {
                await this.$store.dispatch('signInWithEmailAndPassword', formData);
            } catch (error) {
                this.message = error.message;
            }
        },
    },
};
</script>
